import React, { useEffect, useState, useCallback } from 'react';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import _isEmpty from 'lodash/isEmpty';
import { Rnd } from "react-rnd";

const useStyles = makeStyles((theme) => ({
	root: (props) => ({
		backgroundColor: props.backgroundColor,
		height: '100vh'
	}),
	portrait: (props) => ({
		border: handleFrames(props),
		outline: handleBlackWithMatFrame(props)
	})
}));

const handleFrames = (props) => {
	const type = props.frameType;
	switch (type) {
		case 'Black':
			return '10px solid #000000';
		case 'Silver':
			return '10px solid #A3A3A3';
		case 'White':
			return '10px solid white';
		case 'Dark wood':
			return '10px solid #42200d';
		case 'Black with Mat':
			return '6px solid white';
		default:
			return null;
	}
};

const handleBlackWithMatFrame = (props) => {
	if (props.frameType === 'Black with Mat') {
		return '10px solid black';
	}
};

const imageDimFormat = (viewSettinglist, dimension) => {
	if (viewSettinglist.customer.dimFormat === 'inches') {
		return dimension;
	} else if (viewSettinglist.customer.dimFormat === 'cm') {
		return dimension / 2.54;
	} else if (viewSettinglist.customer.dimFormat === 'mm') {
		return dimension / 25.4;
	}
};

function PreviewContainer(props) {
	const classes = useStyles(props);
	const [ styles, setStyles ] = useState({});
	const [ initialStyles, setInitialStyles ] = useState({});
	const [position, setPosition] = useState({
		xAxis: 0,
		yAxis: 0
	})
	const [isDragging, setIsDragging] = useState(false)
	const { viewSettinglist } = props;
	let windowWidth = window.innerWidth;
	let windowHeight = window.innerHeight;
	// DPI here is "virtual wall DPI" — CSS pixels per inch of artwork.
	// window.innerWidth is already in CSS pixels so devicePixelRatio must NOT
	// be involved; multiplying by DPR was causing artwork to render ~3× too
	// small on Retina phones (e.g. 72×3=216 on iPhone 14).
	var dpi = 120; // desktop default
	if (windowWidth <= 576) {
		dpi = 96;  // phones — artwork fills a reasonable portion of the screen
	} else if (windowWidth <= 768) {
		dpi = 96;  // tablets / large phones
	}

	const canvasImage = useCallback(
		(url, ctx) => {
			if (url) {
				var img = new Image();
				img.src = url;
				img.onload = function(e) {
					let imgWidth = '';
					let imgHeight = '';
					let originWidth = window.innerWidth;
					let originHeight = window.innerHeight;
					if (!_isEmpty(viewSettinglist)) {
						let widthInInch = imageDimFormat(viewSettinglist, viewSettinglist.swidth);
						let heightInInch = imageDimFormat(viewSettinglist, viewSettinglist.slength);
						imgWidth = widthInInch * (originWidth / dpi);
						imgHeight = heightInInch * (originHeight / dpi);
						if (originWidth > originHeight) {
							imgWidth = widthInInch * (originHeight / dpi);
							imgHeight = heightInInch * (originHeight / dpi);
						} else {
							imgWidth = widthInInch * (originWidth / dpi);
							imgHeight = heightInInch * (originWidth / dpi);
						}
					}
					var ctxWidth = ctx.canvas.width,
						// portraitWrapper is 40% of viewport height — cap artwork to that
						ctxHeight = ctx.canvas.height * 0.4;
					var ratioWidth = imgWidth / ctxWidth,
						ratioHeight = imgHeight / ctxHeight,
						ratioAspect = ratioWidth > 1 ? ratioWidth : ratioHeight > 1 ? ratioHeight : 1;
					var newWidth = imgWidth / ratioAspect,
						newHeight = imgHeight / ratioAspect;
					setStyles({ width: newWidth, height: newHeight });
					setInitialStyles({width: imgWidth, height: imgHeight });
					setPosition({
						xAxis: (window.innerWidth - newWidth) / 2,
						yAxis: Math.max(0, (window.innerHeight * 0.4 - newHeight) / 2)
					});
				};
			}
		},
		[ viewSettinglist, dpi ]
	);
	
	let minimumWidth = 0
	if(window.innerWidth >= 1200) {
		minimumWidth = 100
	} else if(window.innerWidth >= 996 && window.innerWidth < 1200) {
		minimumWidth = 70
	} else if(window.innerWidth >= 768 && window.innerWidth < 996) {
		minimumWidth = 50
	} else if(window.innerWidth >= 576 && window.innerWidth < 768) {
		minimumWidth = 50
	}
	useEffect(() => {
		if (props.viewSettinglist.image) {
			window.addEventListener(
				'resize',
				() => {
					var ctx = document.getElementById('image-viewer').getContext('2d');
					canvasImage(props.viewSettinglist.image, ctx);
				},
				[ props.viewSettinglist.image ]
			);
		}
	});

	useEffect(() => {
		return () => {
			window.removeEventListener('resize', () => {});
		};
	}, []);

	useEffect(
		() => {
			var ctx = document.getElementById('image-viewer').getContext('2d');
			canvasImage(props.viewSettinglist.image, ctx);
		},
		[ props.pieceWidth, props.pieceHeight, props.viewSettinglist.image, canvasImage ]
	);
	const ImageBox = () => (
		<img
			src={viewSettinglist.image}
			style={styles}
			draggable = {false}
			alt=""
			className={props.frameType === 'Black with Mat' ? `portrait_shadow ${classes.portrait}`:`matFrame_shadow ${classes.portrait}`}
			/>
	  );
	  const gcdRatio = ( initialStyles.height % initialStyles.width )
	  const minimumHeight = minimumWidth / gcdRatio || 0
	return (
		<Grid container className={classes.root} id="wall">
			<div className="portraitWrapper" id="artworks">
   			<Rnd
			    disableDragging= {window.innerWidth >= 1024 ? false : true}
			   	enableResizing = {window.innerWidth >= 1024 ? true : false}
				position={{x: position.xAxis, y: position.yAxis}}
				minHeight={minimumHeight} 
				minWidth={minimumWidth}
				onDrag={(e,d) => {
					setPosition({
						xAxis: d.x,
						yAxis: d.y
				})}}
				onDragStart = { () => setIsDragging(true) }
				onDragStop = { () => setIsDragging(false) }
				bounds='.portraitWrapper'
				lockAspectRatio={true}
				onResize={(e, direction, ref, delta, position) => {
					setStyles({
						height: ref.offsetHeight,
						width: ref.offsetWidth
					})
					setPosition({
						xAxis: position.x,
						yAxis: position.y
					})
    			}}>
      			<ImageBox />
    		</Rnd>
				<canvas id="image-viewer" width={windowWidth} height={windowHeight} style={{ display: 'none' }} />
			</div> 
			<div className="CouchWrapper" id="couch">
				{
					isDragging &&
					<hr style={{ size: '2', border: '2px dashed #6b6767'}}></hr>
				}
				<img src="/assets/images/couch.png" alt="couch" className="couchDimension" />
			</div>
		</Grid>
	);
}

const mapStateToProps = (state, ownProps) => {
	return {
		backgroundColor: state.viewSettings.wallColor,
		viewSettinglist: state.viewSettings.list,
		frameType: state.viewSettings.frame,
		pieceWidth: state.viewSettings.pieceWidth,
		pieceHeight: state.viewSettings.pieceHeight
	};
};

export default connect(mapStateToProps, null)(PreviewContainer);
